/* eslint-disable react/no-array-index-key */
import parse from 'html-react-parser';
import PropTypes from 'prop-types';
import { useState } from 'react';
import backPlan1 from '../../../../assets/images/back-icon-plan-1.png';
import backPlan2 from '../../../../assets/images/back-icon-plan-2.png';
import backPlan3 from '../../../../assets/images/back-icon-plan-3.png';
import glassOrange from '../../../../assets/images/glass-orange.png';
import glassRed from '../../../../assets/images/glass-red.png';
import glassYellow from '../../../../assets/images/glass-yellow.png';
import planFillType1 from '../../../../assets/images/icons/plan-fill-type-1.svg';
import planFillType2 from '../../../../assets/images/icons/plan-fill-type-2.svg';
import planFillType3 from '../../../../assets/images/icons/plan-fill-type-3.svg';
import planImgType1 from '../../../../assets/images/icons/plan-img-type-1.svg';
import planImgType2 from '../../../../assets/images/icons/plan-img-type-2.svg';
import planImgType3 from '../../../../assets/images/icons/plan-img-type-3.svg';
import Text from '../../../../assets/styles/Text';
import CheckoutModal from '../../../../components/CheckoutModal';
import PopUpPlan from '../../../../components/PopUpPlan';
import * as styles from './styles';

export default function Plan({ plan }) {
  const [pagment, setPagment] = useState(false);
  const [checkout, setCheckout] = useState(false);

  const {
    type,
    name,
    price1,
    days1,
    total1,
    price2,
    days2,
    total2,
    price3,
    days3,
    total3,
    description,
    signature,
    valueSignature,
  } = plan;

  const benefits = description.split(',');

  function switchGlass(number) {
    switch (number) {
      case 1:
        return glassYellow;
      case 2:
        return glassOrange;
      case 3:
        return glassRed;
      default:
        return null;
    }
  }

  function switchIcon(number) {
    if (!signature) {
      switch (number) {
        case 1:
          return backPlan1;
        case 2:
          return backPlan2;
        case 3:
          return backPlan3;
        default:
          return null;
      }
    } else {
      switch (number) {
        case 1:
          return planFillType1;
        case 2:
          return planFillType2;
        case 3:
          return planFillType3;
        default:
          return null;
      }
    }
  }

  function formatPrice(price) {
    return price.toFixed(2).replace('.', ',');
  }


  return (
    <styles.Gruop>
      <PopUpPlan
        type={type}
        show={pagment}
        onClose={() => setPagment(false)}
        signature={signature}
      />

      <CheckoutModal
        show={checkout}
        onClose={() => setCheckout(false)}
        plan={plan}
      />

      <styles.Container>
        <styles.Background $glass={() => switchGlass(type)}>
          <styles.Icon $icon={switchIcon(type)} $type={type}>
            <img src={switchIcon(type)} alt="plan" />
          </styles.Icon>

          <styles.GroupInfos $type={type}>
            <styles.Name>
              {type !== 3 && <Text.H3>Plano</Text.H3>}
              {type === 3 && <Text.H4>Super</Text.H4>}
              <Text.H2>{name}</Text.H2>
            </styles.Name>

            {type === 1 && <img src={planImgType1} alt="plan" />}
            {type === 2 && <img src={planImgType2} alt="plan" />}
            {type === 3 && <img src={planImgType3} alt="plan" />}
          </styles.GroupInfos>
        </styles.Background>

        <styles.Body $type={type}>
          <styles.Ul>
            {benefits.map((benefit, index) => (
              <li key={index}>{parse(benefit)}</li>
            ))}
          </styles.Ul>

          {signature && (
            <styles.Signature>
              <Text.H2>R${valueSignature}</Text.H2>
              <Text.Span $bold>Mensal</Text.Span>
            </styles.Signature>
          )}

          {!signature && (
            <styles.GroupPrice>
              <styles.Price>
                <Text.H4>{days1} dias</Text.H4>
                <Text.H2>
                  {formatPrice(price1)}
                  <Text.Span>DIA</Text.Span>
                </Text.H2>
                <Text.Span>
                  Total R$
                  {formatPrice(total1)}
                </Text.Span>
              </styles.Price>

              <div className="line" />

              <styles.Price>
                <Text.H4>{days2} dias</Text.H4>
                <Text.H2>
                  {formatPrice(price2)}
                  <Text.Span>DIA</Text.Span>
                </Text.H2>
                <Text.Span>
                  Total R$
                  {formatPrice(total2)}
                </Text.Span>
              </styles.Price>

              <div className="line" />

              <styles.Price>
                <Text.H4>{days3} dias</Text.H4>
                <Text.H2>
                  {formatPrice(price3)}
                  <Text.Span>DIA</Text.Span>
                </Text.H2>
                <Text.Span>
                  Total R$
                  {formatPrice(total3)}
                </Text.Span>
              </styles.Price>
            </styles.GroupPrice>
          )}

          <styles.GroupButton $type={type}>
            <button
              type="button"
              className="info"
              onClick={() => setPagment(true)}
            >
              <Text.Span>VER EXPLICAÇÃO COMPLETA</Text.Span>
            </button>

            <button
              type="button"
              className="buy"
              onClick={() => setCheckout(true)}
            >
              <Text.H2>
                {!signature ? 'Quero esse plano' : 'Quero essa assinatura'}
              </Text.H2>
            </button>
          </styles.GroupButton>
        </styles.Body>
      </styles.Container>
    </styles.Gruop>
  );
}

Plan.propTypes = {
  plan: PropTypes.shape().isRequired,
};
